import { Box, Typography } from "@mui/material";
import { ReactNode, useMemo } from "react";
import { If } from "./If";
import { noop } from "../utils/operations";

const style = {
	containerWithIcon: {
		display: "flex",
		gap: "16px",
		alignItems: "center",
		width: "100%",
	},
	disabled: {
		opacity: 0.6,
	},
};

export function HamburgerOptions(
	props: Readonly<{
		title: string;
		action: () => void;
		testId?: string;
		icon?: ReactNode;
		textStyle?: Record<string, string>;
		disabled?: boolean;
	}>
) {
	const textStyle = useMemo(() => {
		const base = props.textStyle || {};
		const extra = props.disabled ? style.disabled : {};
		return { ...base, ...extra };
	}, [props.textStyle, props.disabled]);
	return (
		<Box
			sx={{
				...(props.icon ? style.containerWithIcon : {}),
				display: "flex",
				flex: 1,
				padding: "8px",
			}}
			onClick={props.disabled ? noop : props.action}
		>
			<If condition={props.icon}>
				<Box sx={props.textStyle || {}}>{props.icon}</Box>
			</If>
			<Typography
				variant="h3"
				style={textStyle}
				data-testid={props.testId}
				component={"span"}
				sx={{ width: "100%" }}
			>
				{props.title}
			</Typography>
		</Box>
	);
}
